import React, { useEffect, useState } from 'react';
import { confirmSignUp } from 'aws-amplify/auth';

function getQueryParams() {
  const url = new URL(window.location.href);
  return {
    data: url.searchParams.get('data'),
    code: url.searchParams.get('code'),
  };
}

export default function VerifyEmailHandler() {
  const [status, setStatus] = useState('Confirming your email...');
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      try {
        const { data, code } = getQueryParams();

        if (!data || !code) {
          throw new Error('Missing verification data.');
        }

        const decoded = JSON.parse(atob(data));
        const { userName, redirectUrl } = decoded;

        await confirmSignUp({
          username: userName,
          confirmationCode: code,
        });

        window.location.replace(`${redirectUrl}?verified=1&username=${encodeURIComponent(userName)}`);
      } catch (err) {
        console.error('Verification failed:', err);
        setError(err.message || 'Verification failed');
        setStatus('We could not verify your email.');
      }
    };

    run();
  }, []);

  return (
    <div className="container" style={{ paddingTop: 64, textAlign: 'center' }}>
      <h2>{status}</h2>
      {error ? <p>{error}</p> : <p>Please wait while we finish setting up your account.</p>}
    </div>
  );
}